import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { AiVoiceoverCanvas } from '@/features/app-shell/canvases/ai-voiceover-canvas'

export const Route = createFileRoute('/app/tools/voiceover')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppToolsVoiceoverPage,
})

function AppToolsVoiceoverPage() {
  return (
    <AppShell activePath="/app">
      <AiVoiceoverCanvas />
    </AppShell>
  )
}
